
export default [
  {
    nome: 'Mover Processos',
    icon: 'fileCode-img',
    permissao: 'VIEW_MOVER_PROCESSOS',
    routeName: 'MOVE_PROCESSO'
  },
  {
    nome: 'Mover Processos',
    icon: 'fileCode-img',
    permissao: 'VIEW_MOVIMENTAR_PROCESSOS',
    routeName: 'MOVER_PROCESSO'
  },
  {
    nome: 'Ajustar Processos',
    icon: 'fileCog-img',
    permissao: 'VIEW_AJUSTAR_PROCESSOS',
    routeName: 'AJUSTAR_PROCESSOS'
  },
  {
    nome: 'Distribuir Processos',
    icon: 'filePieChart-img',
    permissao: 'VIEW_DISTRIBUIR_PROCESSO',
    routeName: 'TRAMITA_PROCESSO'
  },
  {
    nome: 'Voltar Caixa Processos',
    icon: 'undo-img',
    permissao: 'VIEW_VOLTAR_CAIXA_PROCESSO',
    routeName: 'VOLTA_PROCESSO'
  },
  {
    nome: 'Atualizar Processos',
    icon: 'filePenLine-img',
    permissao: 'VIEW_ATUALIZAR_PROCESSOS',
    routeName: 'ATUALIZAR_PROCESSO'
  },
  {
    nome: 'Mover por remessa',
    icon: 'fileStack-img',
    permissao: 'VIEW_MOVEL_REMESSA',
    routeName: 'MOVER_POR_REMESSA'
  },
  {
    nome: 'Gestão Fila Análise Automatizada',
    icon: 'fileSearch-img',
    permissao: 'VIEW_GESTAO_FILA_ANALISE',
    routeName: 'GESTAO_FILA_ANALISE'
  },
  {
    nome: 'Trocar Usuario',
    icon: 'userRoundCog-img',
    permissao: 'VIEW_TROCAR_USUARIO',
    routeName: 'TROCAR_USUARIO'
  },
  {
    nome: 'Retificar em Massa',
    icon: 'folders-img',
    permissao: 'VIEW_RETIFICACAO_EM_MASSA',
    routeName: 'RETIFICAR_EM_MASSA'
  },
  {
    nome: 'Gerenciamento de Modulos',
    icon: 'foldersCog-img',
    permissao: 'VIEW_GERENCIAMENTO_MODULOS',
    routeName: 'GERENCIAMENTO_DE_MODULOS'
  },
  {
    nome: 'Verificação Status no Flowable',
    icon: 'clipboardCheck-img',
    permissao: 'VIEW_STATUS_FLOWABLE',
    routeName: 'VERIFICA_STATUS_FLOWABLE'
  },
  {
    nome: 'Encerrar conversa',
    icon: 'encerrarConversa-img',
    permissao: 'VIEW_ENCERRAR_CONVERSA',
    routeName: 'ENCERRAR_CONVERSA_MANUTENCAO'
  },
  {
    nome: 'Upload Planta',
    icon: 'upload',
    permissao: 'VIEW_UPLOAD_PLANTA',
    routeName: 'UPLOAD_PLANTA'
  },
  {
    nome: 'Gerenciar WhatsApp',
    icon: 'wap-img',
    permissao: 'VIEW_GERENCIAR_WHATSAPP',
    routeName: 'WAP_CLIENT'
  },
  {
    nome: 'Recall Planta',
    icon: 'fileSliders-img',
    permissao: 'VIEW_RECALL_PLANTA',
    routeName: 'REACLL_PLANTA'
  },
  {
    nome: 'Recall Fotos Reurb',
    icon: 'switchCamera-img',
    permissao: 'VIEW_RECALL_FOTOS_REURB',
    routeName: 'CAIXA_PROCESSO'
  },
  {
    nome: 'Processos CAR',
    icon: 'download',
    permissao: 'VIEW_PROCESSOS_CAR',
    routeName: 'PROCESSOS_CAR_GERADO'
  },
  {
    nome: 'Chave Segurança',
    icon: 'key',
    permissao: 'GERAR_CHAVE_SWAGGRER',
    routeName: 'chave-seguranca'
  },
  {
    nome: 'Info Sistema',
    icon: 'chart-bar',
    permissao: 'VIEW_GERENCIAMENTO_MODULOS',
    routeName: 'INFO_SISTEMA'
  }
]



// WEBPACK FOOTER //
// ./src/screens/manutencao/menu.js